export default __webpack_public_path__ + "static/contact-257b2a6343af1a04f2360cdb7e43bf4f.svg";